import React, { StrictMode, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// @ts-ignore
import { GlobalFocusToggle } from '@els/els-react--utils';
import 'regenerator-runtime/runtime';
import AppRouter from './AppRouter';
import store from './app/store';
import logConfig from './log-config';
// import reportWebVitals from './reportWebVitals';
import './assets/base.scss';

const AppWrapper = logConfig.strictMode ? StrictMode : Fragment;

ReactDOM.render(
    <AppWrapper>
        <GlobalFocusToggle>
            <Provider store={store}>
                <AppRouter />
            </Provider>
        </GlobalFocusToggle>
    </AppWrapper>,
    document.getElementById('root')
);
// module.hot.accept();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
